import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormStack } from '../../components/forms/FormStack';
import type { UsersFilter } from '../../hooks/useUsersFilter';

interface Props {
  filter: UsersFilter;
}

export const UsersFilterControls = (props: Props) => {
  const { filter } = props;

  return (
    <FormStack orientation='horizontal'>
      <ChakraV3.Stack maxW='2xs'>
        <ChakraV3.Input
          onChange={(e) => filter.onNameFilter(e.target.value)}
          size='md'
          placeholder='All users'
        />
      </ChakraV3.Stack>
    </FormStack>
  );
};
